import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw24px = 'M11.884 6.1V18h-1.445v-5.559H4.744V18H3.299V6.1h1.445v5.134h5.695V6.1h1.445Zm4.184 10.676h5.848V18h-7.26v-.867c0-2.108.902-3.213 2.296-4.216l1.734-1.224c1.173-.833 1.7-1.326 1.7-2.295v-.459c0-.918-.748-1.87-2.33-1.87-1.087 0-1.937.289-3.008 1.105l-.68-.901c1.088-.901 2.278-1.377 3.74-1.377 2.363 0 3.74 1.479 3.74 3.026v.51c0 1.19-.714 2.159-2.55 3.4l-1.428.952c-1.428.969-1.768 1.785-1.802 2.992Z';
const icons = {
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const TextH2Icon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'textH2'));
TextH2Icon.displayName = 'TextH2Icon';
TextH2Icon.propTypes = Icon.propTypes;
TextH2Icon.renderIcon = props => /*#__PURE__*/React.createElement(TextH2Icon, props);
export default TextH2Icon;
//# sourceMappingURL=TextH2Icon.js.map